(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[27140],{

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 27140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CategoryList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17439);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








function CategoryList({ props ={}  }) {
    const showCategoryGroups = props.categoryGroups?.groups && props.categoryGroups.groups.length > 0;
    const { 0: searchValue , 1: setSearchValue  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const categoryGroupsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: showLeftShadow , 1: setShowLeftShadow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: showRightShadow , 1: setShowRightShadow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: shouldCenter , 1: setShouldCenter  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { title , description , categoriesList , addLinkButton , buttonText , enableSearch , searchPlaceholder ,  } = props;
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const domainCategories = domain?.categories;
    const queryString = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
        "genericRoute",
        "keyword",
        "replaceKeyword",
        "slug", 
    ]);
    const { visitDetails , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const { 0: activeCategoryGroup , 1: setActiveCategoryGroup  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(showCategoryGroups && props.categoryGroups?.groups ? props.categoryGroups?.groups[0] : null);
    const handleScroll = ()=>{
        const container = categoryGroupsRef.current;
        if (!container) return;
        const { scrollLeft , scrollWidth , clientWidth  } = container;
        // Check if content overflows
        const hasOverflow = scrollWidth > clientWidth;
        setShouldCenter(!hasOverflow);
        // Update shadow visibility
        setShowLeftShadow(scrollLeft > 0);
        setShowRightShadow(scrollLeft < scrollWidth - clientWidth - 1);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const container = categoryGroupsRef.current;
        if (!container) return;
        // Initial check - use timeout to ensure DOM has rendered
        const timeoutId = setTimeout(()=>{
            handleScroll();
        }, 0);
        // Add scroll listener
        container.addEventListener("scroll", handleScroll);
        // Check on resize
        window.addEventListener("resize", handleScroll);
        return ()=>{
            clearTimeout(timeoutId);
            container.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [
        props.categoryGroups?.groups
    ]);
    const finalCategoriesList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const mappedCategories = [];
        if (!categoriesList || categoriesList?.auto) {
            domainCategories?.forEach((category)=>{
                mappedCategories.push({
                    link: `/${category.slugAlias ?? category.slug}`,
                    title: category.label ?? category.name ?? "",
                    description: "",
                    icon: category.icon?.fullPath ?? "",
                    buttonText: buttonText ?? "Get A Free Quote"
                });
            });
        } else {
            categoriesList.categories?.forEach((category)=>{
                mappedCategories.push({
                    link: `${category.link ?? ""}`,
                    title: category.title ?? "",
                    description: category.description ?? "",
                    icon: category.image ?? "",
                    buttonText: category.buttonText ?? buttonText ?? "Get A Free Quote"
                });
            });
        }
        const finalFilteredCategories = mappedCategories.filter((el)=>{
            return el.title.toLowerCase().includes(searchValue.trim().toLowerCase());
        });
        if (showCategoryGroups) {
            return finalFilteredCategories.filter((categoryEl)=>{
                return activeCategoryGroup?.categories?.includes(categoryEl?.title);
            });
        }
        return finalFilteredCategories;
    }, [
        categoriesList,
        domainCategories,
        searchValue,
        activeCategoryGroup
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["category-list"])} `,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `mb-6 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title)}`,
                        dangerouslySetInnerHTML: {
                            __html: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .replacePlaceholders */ .wT)(title, {
                                region: visitDetails.region,
                                city: visitDetails?.city,
                                category: category?.label ?? category?.name
                            })
                        }
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .replacePlaceholders */ .wT)(description, {
                                region: visitDetails.region,
                                city: visitDetails?.city,
                                category: category?.label ?? category?.name
                            })
                        },
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description)
                    }),
                    enableSearch && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "text",
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().search),
                            placeholder: searchPlaceholder || "Search...",
                            onChange: (e)=>setSearchValue(e.target.value)
                        })
                    }),
                    showCategoryGroups && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().categoryGroupsWrapper)} ${showLeftShadow ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().showLeftShadow) : ""} ${showRightShadow ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().showRightShadow) : ""}`,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shadowLeft)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shadowRight)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: categoryGroupsRef,
                                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().categoryGroupsContainer)} ${shouldCenter ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().centered) : ""}`,
                                children: props.categoryGroups?.groups?.map((group, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().categoryGroup)} ${activeCategoryGroup?.title === group.title ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().activeCategoryGroup) : ""} `,
                                        onClick: ()=>{
                                            setActiveCategoryGroup(group);
                                        },
                                        children: group.title
                                    }, index))
                            })
                        ]
                    })
                ]
            }),
            finalCategoriesList.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().categories),
                children: finalCategoriesList?.map((category, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().category),
                        children: [
                            category.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `flex ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().imageContainer)}`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: category.icon,
                                        layout: "fill",
                                        alt: category.title ?? ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                dangerouslySetInnerHTML: {
                                    __html: category.title ?? ""
                                }
                            }),
                            category.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description),
                                children: category.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: `${category.link}?${queryString}`,
                                className: addLinkButton ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["with-button"]) : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["without-button"]),
                                children: category.buttonText
                            })
                        ]
                    }, index))
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["no-search-results-text"]),
                children: "Sorry, No Results Found"
            })
        ]
    });
}


/***/ }),

/***/ 17439:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","category-list":"styles_category-list__n0IEk","title":"styles_title__XwEbJ","description":"styles_description__YXp4B","categories":"styles_categories__2Lpop","category":"styles_category__YpvkI","imageContainer":"styles_imageContainer__LL8qu","without-button":"styles_without-button__YI3jf","search":"styles_search__J4Xhu","no-search-results-text":"styles_no-search-results-text__cCWNU","categoryGroupsWrapper":"styles_categoryGroupsWrapper__q8y0J","shadowLeft":"styles_shadowLeft__Av_t0","shadowRight":"styles_shadowRight__EudZO","showLeftShadow":"styles_showLeftShadow__bDWQ9","showRightShadow":"styles_showRightShadow__Uv6Zq","categoryGroupsContainer":"styles_categoryGroupsContainer__OC4tB","centered":"styles_centered__wKssH","categoryGroup":"styles_categoryGroup__9tqEf","activeCategoryGroup":"styles_activeCategoryGroup__sPZfg"};

/***/ })

}]);